import React from "react"
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core"
import {formatDinero} from "./../../../utils/formatDinero"
import { useDispatch, useSelector } from "react-redux"
import Swal from "sweetalert2"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { obtenerPLazasPaqueteTerrestre, eliminarPlazaPaqueteTerrrestre } from "../../../ducks/proveedorTerrestreDuck"
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})
const TablaRegistro = () => {
  const {listaPlazasTerrestre, paqueteSelect} = useSelector(store => store.proveedorTerrestre)
  const dispatch = useDispatch();
  const classes = useStyles();
  const onDelete = ({id}) =>{
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '¡Eliminarlo!',
      cancelButtonText: '¡Cancelar!',
      reverseButtons: true
    }).then((result) =>{
      if (result.isConfirmed) {
        dispatch(onLoadAnction({message: ""}))
        dispatch(eliminarPlazaPaqueteTerrrestre({idPaqueteTerrestrePlaza: id})).then(Response =>{
          dispatch(obtenerPLazasPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre })).then((Response) => {
              dispatch(offLoadAction())
              ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
              })
            })
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <TableContainer component={Paper}  className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Habitacion</TableCell>
            <TableCell align="center">Suplemento</TableCell>
            <TableCell align="center">Diponibilidad</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaPlazasTerrestre.map((row, index) => (
            <TableRow key={row?.IdPaqueteProveedorTerrestreTipoPlaza}>
              <TableCell align="center">{`${row.TipoPlaza.Descripcion} - ${row.TipoPlaza.Personas} huésped`}</TableCell>
              <TableCell align="center">{formatDinero(row.Suplemento)}</TableCell>
              <TableCell align="center">{row.Disponibilidad}</TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <Button onClick={() => onDelete({id: row?.IdPaqueteProveedorTerrestreTipoPlaza})}>Eliminar</Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaRegistro;
